import React, { Component } from "react";
import { conditionalWidth, imageAddress, translate } from "../../utils/useful";
import Modal from "../../components/Modal";
import FixedView from "../../components/FixedView";
import RoomHubsListSingleHub from "./RoomHubsListSingleHub";
import ButtonAnimated from "../../components/buttons/ButtonAnimated";


class RoomHubsList extends Component {

    state = {

        isOpen: false,
        hubsMore: [
            { title: 'Mute', icon: '/assets/icons/rooms/hubs/mute.svg', key: 'mute' },
            { title: 'Keek', icon: '/assets/icons/rooms/hubs/keek.svg', key: 'keek' },
        ]
    }



    componentDidMount() {

    }


    open = () => {

        this.setState({ isOpen: true })
    }

    close = () => {

        this.setState({ isOpen: false })
    }

    toggle = (cb) => {
        // console.log('toggle')
        this.setState({ isOpen: !this.state.isOpen }, () => {
            if (cb) {
                cb()
            }
        })

    }

    showAddPeopleModal = () => {

        this.addPeopleModal.showModal()
    }



    showOptions = (index) => {
        // let option = this.state.option
        // if (!option[index]) {
        //     option[index] = false
        // }
        // option[index] = !option[index]
        // this.setState({ option })
        this.personFixedView.showView()
    }




    render() {

        return (
            <>


                <div className={this.state.isOpen ? " scroll-no-scrollbar peoplesListOn window-content-radius" : "peoplesListOff"}>
                    <div className="d-flex flex-column w-100 px-2 pb-3">
                        <div className="flexcb w-100 pt-3 mb-2" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                            <p className="font-size-16 weight-600" style={{ color: '#4F4F4F' }}>{translate('rooms.Participants list')}</p>
                            <button className="flexc hover-gray br-10 p-1" style={{ width: '30px', height: '30px' }} onClick={() => this.showAddPeopleModal()}>
                                <img src="/assets/icons/rooms/add-people.svg" className="w-100" alt="" />
                            </button>
                        </div>

                        <div className='flexcb br-10 w-100 p-2 mb-2 navbar-search-simple' style={{ backgroundColor: '#eee' }}>
                            <img src='/assets/icons/search-gray.svg' width={18} alt="" />
                            <input className='input w-100 font-size-14' placeholder={translate('rooms.Search for people')} />
                        </div>

                        {this.props.joinPendingRequests && this.props.joinPendingRequests.length > 0 && (

                            <div className=" mb-3" >
                                <p className="font-size-14 pb-1 mt-1 text-semibold" style={{ color: '#717D8A' }}>{translate('Pending requests')}</p>

                                {this.props.joinPendingRequests.map((item, index) => {
                                    return (
                                        <div key={item.userId}>

                                            <div className={" w-100 mb-3 "}>
                                                <div className={"w-100 flexc cursor-pointer "} >
                                                    <div>
                                                        <img src={imageAddress(item?.peer_image, 'hub', 'mini')} width={30} height={30} className="mrd-3 br-20 image-cover" alt="" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-14 weight-500 cursor-pointer" style={{ color: '#4F5B67' }}>{item?.peer_name}</p>
                                                        <p className="font-size-12  cursor-pointer" style={{ color: '#777' }}>{translate("Requested to join")}</p>
                                                    </div>
                                                </div>

                                                <div className="flexc mt-1">

                                                    <ButtonAnimated
                                                        iconwidth='24px'
                                                        onClick={() => this.props.approveRequest(true, item.userId)}
                                                        title={translate('Admit')}
                                                        icon='/assets/icons/angle-right-white2.svg'
                                                        textColor={'#fff'}
                                                        invert={false}
                                                        bg={'linear-gradient(90deg, #5856D6, #7D7AFF)'}
                                                        isLoading={this.props.isLoadingApproveRequest[item.userId] == true}
                                                    />

                                                    <div className='mld-2'>

                                                        <ButtonAnimated
                                                            iconwidth='24px'
                                                            onClick={() => this.props.approveRequest(false, item.userId)}
                                                            title={translate('Deny')}
                                                            // icon='/assets/icons/plus-white.svg'
                                                            textColor={'#777'}
                                                            invert={false}
                                                            bg={'#eee'}
                                                            isLoading={this.props.isLoadingApproveRequest[item.userId] == false}
                                                        />

                                                    </div>

                                                </div>
                                                {/* <button className="flexcc" onClick={() => { this.showOptions() }} ref={e => this.personNodeRef = e} >
                                                <img width={24} className={" invert opacity-5 "} src='/assets/icons/rooms/more.svg' alt="" />
                                            </button> */}
                                            </div>
                                        </div>
                                    )
                                })}


                            </div>
                        )}

                        <div className="" style={{ paddingBottom: '56px' }}>

                            <p className="font-size-14 pb-1 mt-1 text-semibold" style={{ color: '#717D8A' }}>{translate('Contributors')}</p>


                            {this.props.uniqueHubs && Object.values(this.props.uniqueHubs).map((item, index) => {
                                return (

                                    <RoomHubsListSingleHub hub={item} key={item.peer_id} />
                                    // <div className="unSelectMember flexc flex-column my-2 py-1" key={item.peer_userId ?? index}>
                                    //     <div className={" w-100 flexcb "}>
                                    //         <div className={" flexc cursor-pointer "} onClick={() => this.setState({ currentMember: item })} style={{}}>
                                    //             <img src={imageAddress(item.peer_image, 'hub', 'mini')} width={30} height={30} className="mrd-3 br-20 image-cover" alt="" />
                                    //             <p className="font-size-14 weight-500 cursor-pointer" style={{ color: '#4F5B67' }}>{item.peer_name}</p>
                                    //         </div>
                                    //         <button className="flexcc" onClick={() => { this.showOptions(index) }} ref={e => this.personNodeRef = e} >
                                    //             <img width={24} className={" invert opacity-5 "} src='/assets/icons/rooms/more.svg' alt="" />
                                    //         </button>
                                    //     </div>
                                    //     <FixedView ref={el => this.personFixedView = el} nodeRef={this.personNodeRef} zIndex={1000} bottomOffset={10} topOffset={0} maxWidth={120} width={120} >
                                    //         <div className='sc-1 shadow-2 br-10 py-1 px-2 w-100' style={{ backgroundColor: "#fff", }}>
                                    //             {this.state.hubsMore.map((prop, index) => {
                                    //                 return (
                                    //                     <div className="bb-gray pb-1">
                                    //                         <div className="flexc w-100 optionMember pt-1" style={{ zIndex: 100 }}>
                                    //                             <button className="flexc">
                                    //                                 <img src='/assets/icons/rooms/microphone-off-red.svg' className="mrd-2" alt="" />
                                    //                                 <p style={{ color: '#DB302A' }}>{translate(prop.title)}</p>
                                    //                             </button>
                                    //                         </div>
                                    //                     </div>
                                    //                 )
                                    //             })}
                                    //         </div>
                                    //     </FixedView>

                                    // </div>
                                )
                            })}
                        </div>
                    </div>
                </div>



                <Modal maxWidth={400} maxHeight={400} className="" ref={(e) => this.addPeopleModal = e}  >
                    <div className='d-flex w-100 h-100 window-content-radius flexcc'>
                        <div className="laterLinkModal px-3 py-4 w-100 " style={{}}>
                            <div className="w-100 flexcb">
                                <p className='font-size-15 weight-500 pb-2'>{translate('rooms.Add people')}</p>
                                <button className="flexc hover-gray br-10 py-1 px-2">
                                    <p className="font-size-14 main-c7">{translate('rooms.Invite')}</p>
                                    <img src="/assets/icons/rooms/add-purple.svg" width={25} alt="" />
                                </button>
                            </div>
                            <div className="w-100 my-1">
                                <input className='copyLinkRoom w-100 br-10 py-2 px-2 font-size-14' name='link' id='link' placeholder={translate('rooms.Enter name or Email')} />
                            </div>
                            <div className="w-100 pb-1">
                                <p className="font-size-14">{translate('rooms.Suggestions')}</p>
                            </div>
                            <div className="w-100 scroll-no-scrollbar" style={{ maxHeight: '300px' }}>
                                {/* {this.state.people.map((item, index) => {
                                    return (
                                        <div className="w-100 flexcb px-2" key={item._id}>
                                            <div className="flexc my-2 py-1 px-1 " style={{}}>
                                                <img src={item.img} width={30} className="mrd-3" style={{}} alt="" />
                                                <p className="font-size-14" style={{ color: '#4F5B67' }}>{item.name}</p>
                                            </div>
                                            <img src='/assets/icons/rooms/add-purple.svg' alt="" />
                                        </div>
                                    )
                                })} */}
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }


}
export default RoomHubsList